import React, {Component} from 'react';
import './onlinePay.layout.sass';
import {Form, Schema, FormGroup, FormControl, Icon, Radio, ControlLabel, Row, Col, RadioGroup, Button} from "rsuite";
import {ConvertToPersianNumber} from "../../script";
import Saman from '../../assets/image/saman.png';
import Parsian from '../../assets/image/parsian.png';
import Axios from 'axios'
import {HandleErorr, Setting} from "../../setting";

class OnlinePayLayout extends Component {
    constructor(props) {
        super(props);
        const formInit = {
            phone: '',
            full_name: '',
            cash: '',
            bank: 'saman'
        };
        this.state = {
            formValue: formInit,
            loading: false
        };
    }

    render() {
        const {formValue, loading} = this.state;
        const {StringType, NumberType} = Schema.Types;
        const Model = Schema.Model({
            phone: NumberType().isRequired('لطفا شماره تلفن خود را وارد کنید'),
            full_name: StringType().isRequired("لطفا نام و نام‌خانوادگی خود را وارد کنید"),
            cash: NumberType().isRequired("لطفا مبلغ مورد نظر خودتان را وارد کنید"),
            bank: StringType().isRequired('بانک لازم است')
        });

        const HandleSubmitForm = (isTrusted) => {
            const {phone, full_name, cash, bank} = this.state.formValue;

            this.setState({
                loading: true
            });

            if(isTrusted){
                Axios.post(`${Setting.apiUrl}api/onlineCharge/add`,
                    {
                        "name" : full_name,
                        "phone" : phone,
                        "bank" : bank,
                        "price" : cash,
                    },
                    {Accept: "application.json", contentType: "application.json"})
                    .then(res => {
                        if(res.data.bank === "saman"){
                            document.getElementById('hide-form2').innerHTML = res.data.form;
                            document.getElementById('samanpeyment').submit();
                        } else if(res.data.bank === "parsian"){
                            window.open(`${res.data.bankUrl}`)
                        }
                    })
                    .catch(res => {
                        HandleErorr(res)
                        this.setState({
                            loading: false
                        })
                    })
            }
        }

        return (
            <div className='online-pay-page'>
                <Form
                    formValue={formValue}
                    onChange={(newValue) => {
                        this.setState({
                            formValue: newValue
                        })
                    }}
                    model={Model}
                    onSubmit={(value)=>HandleSubmitForm(value)}
                >
                    <div className='online-pay-content'>
                        <div className='online-pay-titre'>
                            <Icon icon='circle'/><strong>مشخصات واریز</strong>
                        </div>
                        <div className='online-pay'>
                            <Row>
                                <Col sm={8} xs={24}>
                                    <FormGroup>
                                        <ControlLabel>تلفن همراه</ControlLabel>
                                        <FormControl name='phone' placeholder='با صفر وارد کنید'/>
                                    </FormGroup>
                                </Col>
                                <Col sm={8} xs={24}>
                                    <FormGroup>
                                        <ControlLabel>نام و نام‌خانوادگی</ControlLabel>
                                        <FormControl name='full_name' placeholder='فارسی بنویسید'/>
                                    </FormGroup>
                                </Col>
                                <Col sm={8} xs={24}>
                                    <FormGroup>
                                        <ControlLabel>مبلغ <small>(تومان)</small></ControlLabel>
                                        <FormControl name='cash' placeholder='مبلغ به تومان'/>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                        <Row>
                            <Col sm={12} xs={24}>
                                <div className='online-pay-titre'>
                                    <Icon icon='circle'/><strong>پرداختی شما به زیتونیکس</strong>
                                </div>
                                {
                                    formValue.full_name && formValue.cash && formValue.phone ?
                                        <div className='white-pading'>
                                            <Row>
                                                <Col sm={12} xs={24}>
                                                    <h3><span
                                                        className='value-cash-span'>{ConvertToPersianNumber(formValue.cash)}</span>
                                                        <small>تومان</small>
                                                    </h3>
                                                </Col>
                                                <Col sm={12} xs={24}>
                                                    <h5 style={{marginBottom: '10px'}}>{formValue.full_name}</h5>
                                                    <span>{formValue.phone}</span>
                                                </Col>
                                            </Row>
                                        </div>
                                        : null
                                }
                            </Col>
                            <Col sm={12} xs={24}>
                                <div className='online-pay-titre'>
                                    <Icon icon='circle'/><strong>درگاه پرداخت</strong>
                                </div>
                                <div className='white-pading'>
                                    <Row>
                                        <FormGroup>
                                            <FormControl accepter={RadioGroup} name='bank'>
                                                <Col sm={12} xs={24}>
                                                    <Radio value='saman'>
                                                        <img src={Saman} alt='saman portal'/>
                                                    </Radio>
                                                </Col>
                                                <Col sm={12} xs={24}>
                                                    <Radio value='parsian'>
                                                        <img src={Parsian} alt='parsian portal'/>
                                                    </Radio>
                                                </Col>
                                            </FormControl>
                                        </FormGroup>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className='online-pay-submit-area'>
                        <Button loading={loading} disabled={!formValue.full_name && !formValue.cash && !formValue.phone} type='submit'>پرداخت</Button>
                    </div>
                </Form>
                <div id='hide-form2'/>
            </div>
        );
    }
}

export default OnlinePayLayout;